import React from 'react';
import GoBackIcon from '@/assets/logos/simple-arrow-left.svg';
import './_goBack.scss';
import cs from '@/utils/classNameConcatString';

interface IProps {
  white?: boolean;
  goBack: () => void;
}

const GoBack = (props: IProps) => {
  const { white, goBack } = props;

  return (
    <button className={cs('go-back', white ? 'white' : '')} onClick={goBack}>
      <div className="go-back__icon">
        <GoBackIcon className="" />
      </div>
      <span>Tilbage</span>
    </button>
  );
};

export default GoBack;
